import Typography from 'typography'
import altonTheme from 'typography-theme-alton'
import * as colors from './theme/colors'
import _ from 'lodash'

const fallbackFonts = [
  '-apple-system',
  'system-ui',
  'BlinkMacSystemFont',
  'Segoe UI',
  'Roboto',
  'Oxygen-Sans',
  'Ubuntu',
  'Cantarell',
  'Helvetica Neue',
  'sans-serif',
  'Apple Color Emoji',
  'Segoe UI Emoji',
  'Segoe UI Symbol',
  'sans-serif',
]

const siteTheme = {
  baseFontSize: '16px',
  baseLineHeight: 1.25,
  scaleRatio: 2.5,
  blockMarginBottom: 1,

  bodyColor: colors.indigo[5],
  bodyColor: '#404247',

  headerWeight: 700,
  headerFontFamily: ['Catamaran', ...fallbackFonts],

  bodyWeight: 400,
  boldWeight: 700,
  bodyFontFamily: ['verta', ...fallbackFonts],

  overrideStyles: ({ adjustFontSizeTo, scale, rhythm }, options) => ({
    a: {
      color: colors.indigo[6],
      textDecoration: 'none',
    },
    'a:hover,a:active': {
      color: options.bodyColor,
    },
    // blockquote: {
    //   ...scale(1 / 5),
    //   color: gray(41),
    //   fontStyle: 'italic',
    //   paddingLeft: rhythm(13 / 16),
    //   marginLeft: 0,
    //   borderLeft: `${rhythm(3 / 16)} solid ${gray(10)}`,
    // },
    // 'blockquote > :last-child': {
    //   marginBottom: 0,
    // },
    // 'blockquote cite': {
    //   ...adjustFontSizeTo(options.baseFontSize),
    //   color: options.bodyColor,
    //   fontWeight: options.bodyWeight,
    // },
    // 'blockquote cite:before': {
    //   content: '"— "',
    // },
    // [MOBILE_MEDIA_QUERY]: {
    //   html: {
    //     fontSize: `${16 / 16 * 100}%`,
    //   },
    //   blockquote: {
    //     marginLeft: rhythm(-3 / 4),
    //     marginRight: 0,
    //     paddingLeft: rhythm(9 / 16),
    //   },
    // },
  }),
}

delete altonTheme.googleFonts
let typography = new Typography(_.defaultsDeep({}, siteTheme, altonTheme))

export default typography



// WEBPACK FOOTER //
// ./src/typography.js